export var ScriptLoadingState;
(function (ScriptLoadingState) {
    ScriptLoadingState["NOT_LOADED"] = "NOT_LOADED";
    ScriptLoadingState["ON_HOLD"] = "ON_HOLD";
    ScriptLoadingState["LOADING"] = "LOADING";
    ScriptLoadingState["LOADED"] = "LOADED";
})(ScriptLoadingState || (ScriptLoadingState = {}));
